import {gql} from '@apollo/client';
import {PodRiskReviewFiltersTypeInput} from './getPodRiskReviewPageList';

/** 舆情 POD 审核计数（与列表同筛选条件）；用于 Tab 角标等仅需数字的场景 */
export const GET_POD_RISK_REVIEW_COUNT = gql`
    query GetPodRiskReviewCount($filters: PodRiskReviewFiltersTypeInput) {
        getPodRiskReviewCount(filters: $filters)
    }
`;

export interface GetPodRiskReviewCountResponse {
    getPodRiskReviewCount: number;
}

export interface GetPodRiskReviewCountInput {
    filters?: PodRiskReviewFiltersTypeInput;
}
